module.exports = __webpack_public_path__ + "img/28_81.5fcf72c5.png";